import { useDispatch } from "react-redux";

import { logout } from "@/redux/authorization/authorization.slice";
import { LOGOUT_REASON_MANUAL, setLogoutReason } from "@/utils/logout-redirect";

const useLogout = () => {
  const dispatch = useDispatch();

  const logoutHandler = () => {
    setLogoutReason(LOGOUT_REASON_MANUAL);

    dispatch(logout());
  };
  return logoutHandler;
};

export default useLogout;
